import { useEffect } from "react";
import { useSettings, useTheme } from "./providers";

const hexToRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const hexToHsl = (h) => {
  const [r, g, b] = hexToRgb(h).map((v) => v / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  let hue = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    hue = (max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4) * 60;
  }
  return `${Math.round(hue)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const SiteApplier = () => {
  const { settings } = useSettings();
  const { setTheme } = useTheme();
  useEffect(() => {
    if (!settings) return;
    const { theme, branding } = settings;
    const accent = /^#[0-9a-f]{6}$/i.test(theme.accent || "") ? theme.accent : "#D4AF37";
    const [r, g, b] = hexToRgb(accent);
    let el = document.getElementById("hh-accent");
    if (!el) { el = document.createElement("style"); el.id = "hh-accent"; document.head.appendChild(el); }
    el.textContent = `:root, .dark { --gold: ${accent}; --gold-soft: rgba(${r},${g},${b},.12); --primary: ${hexToHsl(accent)}; --ring: ${hexToHsl(accent)}; }`;
    if (!theme.allow_toggle || !localStorage.getItem("hh_theme_user")) setTheme(theme.default_mode || "dark");
    document.title = branding.browser_title || branding.site_name;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && branding.meta_description) meta.setAttribute("content", branding.meta_description);
  }, [settings, setTheme]);
  return null;
};
